module.exports = __webpack_public_path__ + "static/media/live16_09_2022.3f2eff20.jpg";